// HELPERS
export const excludeFields = (fields, namesToRemove = []) => fields.filter(field => !namesToRemove.includes(field.name));

export const modifyFields = (fields, overrides = {}) =>
  fields.map(f => (overrides[f.name] ? { ...f, ...overrides[f.name] } : f));

export const pickFields = (fields, namesToPick = []) => fields.filter(field => namesToPick.includes(field.name));

// FIELD LEVEL
export const GENERAL = [
  { name: 'supplier', label: 'Supplier', type: 'text' },
  { name: 'customer', label: 'Customer', type: 'dropdown', dropdownKey: 'CustomerNames' },
];

export const OWNERS = [
  {
    name: 'ownerName',
    label: 'Owner Name',
    type: 'dropdown',
    dropdownKey: 'OwnerNames',
    section: 'Owner',
  },
  {
    name: 'licenseNumber',
    label: 'License',
    type: 'dropdown',
    dropdownKey: 'LicenseNumbers',
    section: 'Owner',
  },
];

export const MAP = [
  { name: 'map', label: 'Mark on Map', type: 'map', section: 'Map' },
  // { name: 'route', label: 'Show Route View', type: 'map', section: 'Map' },
];

export const SUB_COMPARTMENTS = [{ name: 'Sub Compartment', section: 'Sub Compartment' }];

export const SITE_INFO = [
  {
    name: 'isSignalStrengthGood',
    label: 'Is Signal Strength Good?',
    type: 'radio',
    options: ['Yes', 'No'],
    section: 'Site Info',
  },
  {
    name: 'descriptionType',
    label: 'Description Type',
    type: 'dropdown',
    dropdownKey: 'SiteDescriptionType',
    section: 'Site Info',
  },
  { name: 'standingType', label: 'Standing Type', type: 'dropdown', dropdownKey: 'SiteStandingType', section: 'Site Info' },
  { name: 'urea', label: 'Urea', type: 'dropdown', dropdownKey: 'Urea', section: 'Site Info' },
  { name: 'timberQuality', label: 'Timber Quality', type: 'dropdown', dropdownKey: 'TimberQuality', section: 'Site Info' },
  { name: 'access', label: 'Access', type: 'dropdown', dropdownKey: 'Access', section: 'Site Info' },
  { name: 'remainingTreesPerHa', label: 'Remaining Trees per Ha', type: 'text', section: 'Site Info' },
];

export const HAZARDS = [
  { name: 'powerlines', label: 'Power Lines', type: 'dropdown', dropdownKey: 'PowerLines', section: 'Site Hazards' },
  { name: 'groundSlope', label: 'Ground Slope', type: 'dropdown', dropdownKey: 'GroundSlope', section: 'Site Hazards' },
  {
    name: 'groundCondition',
    label: 'Ground Conditions',
    type: 'dropdown',
    dropdownKey: 'GroundCondition',
    section: 'Site Hazards',
  },
  { name: 'streamsDrains', label: 'Stream Drains', type: 'dropdown', dropdownKey: 'StreamsDrains', section: 'Site Hazards' },
  { name: 'others', label: 'Others', type: 'text', section: 'Site Hazards' },
];

export const SITE_VOLUME = [
  { name: 'averageTree', label: 'Average Tree', type: 'input', section: 'Site Volume', disabled: true },
  { name: 'treesPerHectare', label: 'Trees Per Hectare', type: 'input', section: 'Site Volume', disabled: true },
  {
    name: 'percentOfForestCovered',
    label: 'Percent Of Forest Covered',
    type: 'input',
    section: 'Site Volume',
    disabled: true,
  },
  { name: 'siteVolAreaInHa', label: 'Site Volume Area (Ha)', type: 'input', section: 'Site Volume', disabled: true },
  { name: 'totalVolume', label: 'Total Volume', type: 'input', section: 'Site Volume', disabled: true },
  { name: 'totalTons', label: 'Total Tons', type: 'input', section: 'Site Volume', disabled: true },
  { name: 'totalTonsPerHa', label: 'Total Tons Per Hectare', type: 'input', section: 'Site Volume', disabled: true },
  { name: 'totalVolPerHa', label: 'Total Volume Per Hectare', type: 'input', section: 'Site Volume', disabled: true },
];

export const SITE_HARVESTING = [
  { name: 'treeHeight', label: 'Tree Height', type: 'input', section: 'Site Harvesting' },
  { name: 'volumePerWeekHarvestor', label: 'Volume Per Week (Harvester)', type: 'input', section: 'Site Harvesting' },
  { name: 'volumePerWeekForwarder', label: 'Volume Per Week (Forwarder)', type: 'input', section: 'Site Harvesting' },
  { name: 'extractionOver300meters', label: 'Extraction Over 300 Meters', type: 'input', section: 'Site Harvesting' },
  { name: 'tracksWheelchains', label: 'Tracks / Wheel Chains', type: 'input', section: 'Site Harvesting' },
  { name: 'diggerWorkDays', label: 'Digger Work Days', type: 'input', section: 'Site Harvesting' },
  { name: 'chainsawWorkDays', label: 'Chainsaw Work Days', type: 'input', section: 'Site Harvesting' },
];

export const MACHINES = [
  {
    name: 'harvesterMachine',
    label: 'Harvesting Machine',
    type: 'dropdown',
    dropdownKey: 'HarvesterMachine',
    section: 'Machines',
  },
  {
    name: 'extractionMachine',
    label: 'Extraction Machine',
    type: 'dropdown',
    dropdownKey: 'ExtractionMachine',
    section: 'Machines',
  },
];

export const CHECKLIST = [
  {
    name: 'bankAccountDetails',
    label: 'Bank Account Details Provided',
    type: 'checkbox',

    section: 'Checklist',
  },
  {
    name: 'dropPinUpdatedonWhatsApp',
    label: 'Drop Pin Updated on WhatsApp',
    type: 'checkbox',

    section: 'Checklist',
  },
  {
    name: 'dropPinUpdatedonGoogleMaps',
    label: 'Drop Pin Updated on Google Maps',
    type: 'checkbox',

    section: 'Checklist',
  },
  {
    name: 'safetyStatement',
    label: 'Safety Statement Available',
    type: 'checkbox',

    section: 'Checklist',
  },
  {
    name: 'copyoffellinglicensesattached',
    label: 'Copy of Felling Licenses Attached',
    type: 'checkbox',

    section: 'Checklist',
  },
  {
    name: 'serviceItemsforMachineandMachineServicesUptodate',
    label: 'Machine Service Items Up To Date',
    type: 'checkbox',

    section: 'Checklist',
  },
  {
    name: 'confirmCertifiedFireExtinguisheronsite',
    label: 'Certified Fire Extinguisher on Site',
    type: 'checkbox',

    section: 'Checklist',
  },
  { name: 'safetySignserected', label: 'Safety Signs Erected', type: 'checkbox', section: 'Checklist' },
  {
    name: 'siteMonitoringForms',
    label: 'Site Monitoring Forms Available',
    type: 'checkbox',

    section: 'Checklist',
  },
  {
    name: 'googleHarvestPlancompleted',
    label: 'Google Harvest Plan Completed',
    type: 'checkbox',

    section: 'Checklist',
  },
  {
    name: 'jotformHarvestPlansenttoOperator',
    label: 'Jotform Harvest Plan Sent to Operator',
    type: 'checkbox',

    section: 'Checklist',
  },
  {
    name: 'isPlantHealthCheckDone',
    label: 'Plant Health Check Done',
    type: 'checkbox',

    section: 'Checklist',
  },
];

export const FINALIZE = [
  { name: 'siteNotesforOperatorsOnly', label: 'Site Notes for Operators Only', type: 'text', section: 'Finalize' },
  { name: 'siteNotesforHaulageOnly', label: 'Site Notes for Haulage Only', type: 'text', section: 'Finalize' },
  { name: 'siteNotesforForestManagerOnly', label: 'Site Notes for Forest Manager Only', type: 'text', section: 'Finalize' },
  { name: 'additionalManagementNotes', label: 'Additional Management Notes', type: 'text', section: 'Finalize' },
  { name: 'finaliseAssessment', label: 'Finalise Assessment', type: 'radio', options: ['Yes', 'No'], section: 'Finalize' },
];

export const FIELD_GROUPS = {
  GENERAL,
  OWNERS,
  MAP,
  SITE_INFO,
  HAZARDS,
  SITE_VOLUME,
  SITE_HARVESTING,
  MACHINES,
  CHECKLIST,
  FINALIZE,
};
